import { useState } from "react";
import { useCopyToClipboard } from "usehooks-ts";

export const CopyEmailToClipboard: React.FC<{ getEmail: () => string }> = ({
  getEmail,
}) => {
  const [, copyToClipboard] = useCopyToClipboard();
  const [isCopied, setIsCopied] = useState<string | null>(null);

  const handleCopyToClipboard = async () => {
    const email = getEmail();
    await copyToClipboard(email);
    setIsCopied(email);
    setTimeout(() => {
      setIsCopied(null);
    }, 2000);
  };

  return (
    <button
      className="w-6 flex-none text-center text-dm-brand-blue-500 hover:text-dm-brand-blue-800"
      type="button"
      title="Copy email to clipboard"
      onClick={handleCopyToClipboard}
    >
      {isCopied ? (
        <i className="fas fa-check" />
      ) : (
        <i className="far fa-clipboard" />
      )}
    </button>
  );
};
